import { Component } from '@angular/core';
import { GlobalVariables } from '../../../common/global-variables';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '../../../app/modules/networking/networking-vcd/networking-vcd.service';
import { VcaAlertsService } from '../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../refresh-shared-service';

@Component({
    selector: 'networks-landing',
    providers: [NetworkService, TranslateService],
    styles: [require('../../../app/modules/networking/networking-vcd/networking-vcd.scss')],
    template: require('./networks-landing.html')
})
export class NetworksLanding {
    private computeNetworkCount: number = 0;
    private transitNetworkCount: number = 0;
    private directConnectCount: number = 0;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private loaded: boolean = false;

    constructor(private service: NetworkService,
                private translateService: TranslateService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService) {
        translateService.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'NetworksLanding';
    };

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.rsService.setParam({
              'loadedComponent': this.currentClassName,
              'detailPageIDName': '',
              'shouldReloadInventoryTree': true
            });
        this.refreshPage();
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.refreshPage();
        }
    }

    refreshPage() {
        this.loaded = false;
        this.service.getDirectConnectList()
            .subscribe(
                (data: any) => {
                    if (data) {
                        this.directConnectCount = data.length;
                        this.loaded = true;
                    }
                },
                error => {
                    this.loaded = true;
                    this.alert.danger(
                        [this.translateService.instant('networkDashboard.directConnectRetrieveError'), error],
                        'get-calls-error-alert');
                }
            );

        this.service.getVDCNetworkList()
            .subscribe(
                (data: any) => {
                    if (data) {
                        this.loaded = true;
                        this.computeNetworkCount = data.length;
                    }
                },
                error => {
                    this.loaded = true;
                    this.alert.danger(
                        [this.translateService.instant('networkDashboard.vdcNetworkRetrieveError'), error],
                        'get-calls-error-alert');
                }
            );
    }
    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/network/networks-landing.component.ts